import Component from "./setNewPassword";

import {bindActionCreators} from "redux";
import {resetPassword} from '../../store/actions/session';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {

    return {

    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({resetPassword}, dispatch);
}

export const SetNewPassword = connect(mapStateToProps, mapDispatchToProps)(Component);